import { useCallback } from 'react';

import useEnum from '@hooks/useEnum';

import ProcessoService from '@services/ProcessoService';

const useTratamentoNomeTiposPendencia = () => {
    const fetch = useCallback(() => ProcessoService.listarTiposPendenciasTratamentoNome(), []);
    const { data, loading, error } = useEnum(fetch);

    return { data, loading, error };
}

export default useTratamentoNomeTiposPendencia;